<template>
  <div
    v-if="hasSelection"
    class="flex items-center justify-between gap-2 md:gap-4 border border-n-gray-1 bg-n-gray-1 dark:bg-n-vars-black-bd/80 dark:border-n-vars-black-bd/80 rounded-lg px-1 md:px-4 py-3 shadow-sm w-full"
  >
    <!-- Left: Close button, Counter, and Toggle Select -->
    <div class="flex items-center gap-2 md:gap-4">
      <woot-button
        color-scheme="secondary"
        variant="clear"
        size="small"
        icon="i-lucide-x"
        class="!rounded-full"
        @click="$emit('clear-selection')"
        :title="$t('BUSINESS_DATA.GENERAL.BULK_CLEAR')"
      />
      <span class="text-sm font-medium text-slate-700 dark:text-slate-300">
        {{ $t('BUSINESS_DATA.GENERAL.BULK_SELECTED', { count: selectedCount }) }}
      </span>
      <woot-button
        v-if="showToggleSelect"
        variant="smooth"
        size="small"
        @click="$emit('toggle-select-page')"
        class="text-xs"
      >
        {{ isAllSelectedOnPage ? $t('BUSINESS_DATA.GENERAL.BULK_UNSELECT_PAGE') : $t('BUSINESS_DATA.GENERAL.BULK_SELECT_PAGE') }}
      </woot-button>
    </div>

    <!-- Right: Action buttons -->
    <div class="flex items-center gap-2">
      <woot-button
        color-scheme="secondary"
        variant="clear"
        size="small"
        :loading="bulkAction === 'activate'"
        :disabled="canActivate === false"
        @click="$emit('activate')"
        :title="canActivate === false ? ($t('BUSINESS_DATA.AI_RULES.ACTIVATE_LIMIT_TOOLTIP') || 'Maximum 5 active rules allowed') : $t('BUSINESS_DATA.GENERAL.BULK_ACTIVATE_BUTTON', { count: selectedCount })"
        class="text-xs !px-2 !justify-center md:!justify-start"
      >
        <div class="flex items-center">
          <lucide-icon name="check" size="14" class="flex-shrink-0" />
          <span class="ml-2 hidden md:inline">{{ $t('BUSINESS_DATA.GENERAL.BULK_ACTIVATE_BUTTON', { count: selectedCount }) }}</span>
        </div>
      </woot-button>
      <woot-button
        size="small"
        color-scheme="secondary"
        variant="clear"
        :loading="bulkAction === 'deactivate'"
        @click="$emit('deactivate')"
        :title="$t('BUSINESS_DATA.GENERAL.BULK_DEACTIVATE_BUTTON', { count: selectedCount })"
        class="text-xs !px-2 !justify-center md:!justify-start"
      >
        <div class="flex items-center">
          <lucide-icon name="eye-off" size="14" class="flex-shrink-0" />
          <span class="ml-2 hidden md:inline">{{ $t('BUSINESS_DATA.GENERAL.BULK_DEACTIVATE_BUTTON', { count: selectedCount }) }}</span>
        </div>
      </woot-button>
      <woot-button
        variant="clear"
        size="small"
        color-scheme="secondary"
        :loading="isBulkDeleting"
        @click="$emit('delete')"
        :title="$t('BUSINESS_DATA.GENERAL.BULK_DELETE_BUTTON', { count: selectedCount })"
        class="text-xs !px-2 !justify-center md:!justify-start"
      >
        <div class="flex items-center">
          <lucide-icon name="trash" size="14" class="flex-shrink-0" />
          <span class="ml-2 hidden md:inline">{{ $t('BUSINESS_DATA.GENERAL.BULK_DELETE_BUTTON', { count: selectedCount }) }}</span>
        </div>
      </woot-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulkActionsBar',
  props: {
    selectedCount: {
      type: Number,
      required: true,
      default: 0,
    },
    bulkAction: {
      type: String,
      default: '',
      validator: (value) => ['', 'activate', 'deactivate'].includes(value),
    },
    isBulkDeleting: {
      type: Boolean,
      default: false,
    },
    isAllSelectedOnPage: {
      type: Boolean,
      default: false,
    },
    showToggleSelect: {
      type: Boolean,
      default: true,
    },
    canActivate: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['activate', 'deactivate', 'delete', 'clear-selection', 'toggle-select-page'],
  computed: {
    hasSelection() {
      return this.selectedCount > 0
    },
  },
}
</script>
